<template>
  <div class="person-select__role-list">
    <div class="person-select__search">
      <el-input v-model.trim="keyword" clearable placeholder="输入角色名称">
        <template #prefix>
          <i class="icon-search-line person-select__search-icon t-iconfont" />
        </template>
      </el-input>
    </div>

    <div v-loading="loading" class="person-select__list">
      <el-empty
        v-if="!filteredRoleList.length && !loading"
        description="暂无角色"
        :image-size="80"
      />
      <div
        v-for="item in filteredRoleList"
        :key="item.id"
        class="person-select__item"
        :class="{ 'person-select__item--checked': isChecked(item) }"
        @click="emits('select', item)"
      >
        <el-checkbox
          :model-value="isChecked(item)"
          @change="() => {}"
          @click.stop="emits('select', item)"
        />
        <span class="person-select__name">{{ item.roleName }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { getRoleList } from '@/api'

defineOptions({
  name: 'RoleList'
})

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  selectedList: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['select'])

const keyword = ref('')
const loading = ref(false)
const roleList = ref([])
const isSameId = (left, right) => String(left) === String(right)

const filteredRoleList = computed(() => {
  if (!keyword.value) return roleList.value
  return roleList.value.filter((item) => item.roleName.includes(keyword.value))
})
const isChecked = (item) =>
  props.selectedList.some(
    (selected) => selected.property === 'role' && isSameId(selected.id, item.id)
  )

const loadRoleList = async () => {
  loading.value = true
  try {
    const res = await getRoleList({})
    roleList.value = res?.result?.roleList || []
  } catch (error) {
    console.error(error)
    roleList.value = []
  } finally {
    loading.value = false
  }
}

watch(
  () => props.show,
  (visible) => {
    if (!visible) return
    keyword.value = ''
    loadRoleList()
  },
  { immediate: true }
)
</script>

<style scoped lang="less">
.person-select {
  &__role-list {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 16px 16px 0;
  }

  &__search-icon {
    color: #969799;
  }

  &__list {
    flex: 1;
    box-sizing: border-box;
    margin-top: 8px;
    overflow-y: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #f7f8fa;
    }

    :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
      background-color: #7a52f4;
      border-color: #7a52f4;
    }
  }

  &__name {
    margin-left: 8px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
